import { render } from "./StaffDetails.vue?vue&type=template&id=6c7da2cc&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"

import "./StaffDetails.vue?vue&type=style&index=0&id=6c7da2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7da2cc"]])

export default __exports__